/**
 * Display URL for an asset photo (presigned S3 `url`, or local `previewUrl` / blob).
 */
export const getPhotoDisplayUrl = (photo) => {
  if (!photo) return '/placeholder.svg';

  if (typeof photo === 'string') {
    if (photo.startsWith('http') || photo.startsWith('blob:')) {
      return photo;
    }
    return '/placeholder.svg';
  }

  if (typeof photo === 'object') {
    if (photo.url) return photo.url;
    if (photo.previewUrl) return photo.previewUrl;
  }

  return '/placeholder.svg';
};

/**
 * Standardized photo object for UI + S3 upload pipeline.
 */
export const createPhotoObject = (photoData = {}) => ({
  id: photoData.id || null,
  type: 's3',
  fileName: photoData.fileName || photoData.name || 'Unknown',
  fileType: photoData.fileType || photoData.mime_type || 'image/jpeg',
  fileSize: photoData.fileSize || null,
  isExisting: photoData.isExisting || false,
  created_at: photoData.created_at || null,
  url: photoData.url || null,
  previewUrl: photoData.previewUrl || null,
  file: photoData.file || null,
});

export default {
  getPhotoDisplayUrl,
  createPhotoObject,
};
